import { Badge, Btn, CopyBtn, Modal } from "../../components/ui";

const OrdersSection = ({ selectedOrder, setSelectedOrder, selectedOrderLabels, paymentHandles, ordersLoading, orders, setView }) => (
        <div>
          <Modal open={!!selectedOrder} onClose={() => setSelectedOrder(null)} title={selectedOrder?.id}>
            {selectedOrder && (
              <div>
                <div style={{ display: "flex", gap: 12, marginBottom: 20, alignItems: "center", flexWrap: "wrap" }}>
                  <Badge status={selectedOrder.status} />
                  <span style={{ fontFamily: "var(--font-mono)", fontSize: "13px", color: "var(--text-dim)" }}>
                    {new Date(selectedOrder.created_at).toLocaleString(undefined, { dateStyle: "medium", timeStyle: "short" })}
                  </span>
                  {selectedOrder.payment_method && (
                    <span style={{ fontFamily: "var(--font-mono)", fontSize: "11px", color: "var(--text-muted)", background: "var(--surface2)", border: "1px solid var(--border)", borderRadius: "var(--radius)", padding: "2px 8px", textTransform: "uppercase", letterSpacing: "0.05em" }}>
                      {{venmo: "Venmo", cashapp: "CashApp", zelle: "Zelle", card: "Credit Card"}[selectedOrder.payment_method] ?? selectedOrder.payment_method}
                    </span>
                  )}
                </div>
                <div style={{ marginBottom: 20 }}>
                  {(selectedOrder.order_items || []).map((item, i) => (
                    <div key={i} style={{ display: "flex", justifyContent: "space-between", padding: "10px 0", borderBottom: "1px solid var(--border)", fontSize: "14px" }}>
                      <span>{item.name} ×{item.qty}</span>
                      <span style={{ fontFamily: "var(--font-mono)" }}>${(Number(item.price) * item.qty).toFixed(2)}</span>
                    </div>
                  ))}
                </div>
                <div style={{ marginBottom: 20 }}>
                  {(() => {
                    const shippingAmt = Number(selectedOrder.shipping ?? 0);
                    const bulkAmt = Number(selectedOrder.bulk_vial_discount ?? 0);
                    const discountAmt = Number(selectedOrder.coupon_discount ?? 0);
                    const creditAmt = Number(selectedOrder.store_credit_applied ?? 0);
                    // Pre-discount merchandise sum: the stored figure when the order has
                    // one, else the line-item sum for orders placed before it existed (#119).
                    const storedSubtotal = Number(selectedOrder.merchandise_subtotal ?? 0);
                    const subtotalAmt = storedSubtotal > 0 ? storedSubtotal : (selectedOrder.order_items || []).reduce((s, i) => s + Number(i.price) * i.qty, 0);
                    return (
                      <>
                        <div style={{ display: "flex", justifyContent: "space-between", fontSize: "13px", marginBottom: 6 }}>
                          <span style={{ color: "var(--text-dim)" }}>Subtotal</span>
                          <span style={{ fontFamily: "var(--font-mono)" }}>${subtotalAmt.toFixed(2)}</span>
                        </div>
                        {bulkAmt > 0 && (
                          <div style={{ display: "flex", justifyContent: "space-between", fontSize: "13px", marginBottom: 6 }}>
                            <span style={{ color: "var(--green)" }}>10-pack discount</span>
                            <span style={{ fontFamily: "var(--font-mono)", color: "var(--green)" }}>−${bulkAmt.toFixed(2)}</span>
                          </div>
                        )}
                        {discountAmt > 0 && (
                          <div style={{ display: "flex", justifyContent: "space-between", fontSize: "13px", marginBottom: 6 }}>
                            <span style={{ color: "var(--green)" }}>Discount{selectedOrder.coupon_code ? ` (${selectedOrder.coupon_code})` : ""}</span>
                            <span style={{ fontFamily: "var(--font-mono)", color: "var(--green)" }}>−${discountAmt.toFixed(2)}</span>
                          </div>
                        )}
                        {creditAmt > 0 && (
                          <div style={{ display: "flex", justifyContent: "space-between", fontSize: "13px", marginBottom: 6 }}>
                            <span style={{ color: "var(--green)" }}>Store Credit</span>
                            <span style={{ fontFamily: "var(--font-mono)", color: "var(--green)" }}>−${creditAmt.toFixed(2)}</span>
                          </div>
                        )}
                        <div style={{ display: "flex", justifyContent: "space-between", fontSize: "13px", marginBottom: 10, paddingBottom: 10, borderBottom: "1px solid var(--border)" }}>
                          <span style={{ color: "var(--text-dim)" }}>Shipping</span>
                          <span style={{ fontFamily: "var(--font-mono)", color: shippingAmt === 0 ? "var(--green)" : "inherit" }}>
                            {shippingAmt === 0 ? "FREE" : `$${shippingAmt.toFixed(2)}`}
                          </span>
                        </div>
                      </>
                    );
                  })()}
                  <div style={{ display: "flex", justifyContent: "space-between" }}>
                    <strong>Total</strong>
                    <span style={{ fontFamily: "var(--font-mono)", color: "var(--amber)", fontSize: "18px" }}>${Number(selectedOrder.total).toFixed(2)}</span>
                  </div>
                  {selectedOrder.payment_method && (
                    <div style={{ display: "flex", justifyContent: "space-between", fontSize: "13px", marginTop: 10, paddingTop: 10, borderTop: "1px solid var(--border)" }}>
                      <span style={{ color: "var(--text-dim)" }}>Payment method</span>
                      <span style={{ fontFamily: "var(--font-mono)", color: "var(--text)" }}>
                        {{ venmo: "Venmo", cashapp: "CashApp", zelle: "Zelle", card: "Credit Card" }[selectedOrder.payment_method] ?? selectedOrder.payment_method}
                      </span>
                    </div>
                  )}
                </div>
                {selectedOrder.status === "pending payment" && (() => {
                  const method = selectedOrder.payment_method;
                  const isManual = !method || ["venmo", "cashapp", "zelle"].includes(method);
                  if (!isManual) return null;
                  const methodLabels = { venmo: "Venmo", cashapp: "CashApp", zelle: "Zelle" };
                  // If method is known, use its handle directly; otherwise fall back to first configured handle
                  const knownHandles = [
                    { key: "venmo", label: "Venmo", handle: paymentHandles.venmo_handle },
                    { key: "cashapp", label: "CashApp", handle: paymentHandles.cashapp_handle },
                    { key: "zelle", label: "Zelle", handle: paymentHandles.zelle_handle },
                  ].filter(m => m.handle);
                  const matchedMethod = method
                    ? knownHandles.find(m => m.key === method)
                    : knownHandles[0];
                  const resolvedHandle = matchedMethod?.handle ?? null;
                  const resolvedLabel = methodLabels[method] ?? matchedMethod?.label ?? null;
                  return (
                    <div style={{ background: "var(--surface2)", padding: 18, borderRadius: "var(--radius)", border: "1px solid var(--amber-dim)", marginBottom: 12 }}>
                      <p style={{ fontFamily: "var(--font-mono)", fontSize: "10px", color: "var(--amber)", letterSpacing: "0.1em", marginBottom: 12 }}>PAYMENT REQUIRED</p>
                      {resolvedHandle ? (
                        <>
                          {resolvedLabel && (
                            <p style={{ fontSize: "14px", fontWeight: 700, color: "var(--text)", marginBottom: 12 }}>via {resolvedLabel}</p>
                          )}
                          <p style={{ fontFamily: "var(--font-mono)", fontSize: "10px", color: "var(--text-muted)", letterSpacing: "0.08em", marginBottom: 4 }}>SEND TO</p>
                          <div style={{ display: "flex", alignItems: "center", gap: 10, marginBottom: 12 }}>
                            <p style={{ fontFamily: "var(--font-mono)", fontSize: "20px", color: "var(--amber)", fontWeight: 700, wordBreak: "break-all" }}>{resolvedHandle}</p>
                            <CopyBtn value={resolvedHandle} />
                          </div>
                          <p style={{ fontFamily: "var(--font-mono)", fontSize: "10px", color: "var(--text-muted)", letterSpacing: "0.08em", marginBottom: 4 }}>AMOUNT</p>
                          <div style={{ display: "flex", alignItems: "center", gap: 10, marginBottom: 12 }}>
                            <p style={{ fontFamily: "var(--font-mono)", fontSize: "20px", color: "var(--text)", fontWeight: 700 }}>${Number(selectedOrder.total).toFixed(2)}</p>
                            <CopyBtn value={Number(selectedOrder.total).toFixed(2)} />
                          </div>
                          <p style={{ fontSize: "13px", color: "var(--text-dim)", lineHeight: 1.6 }}>
                            Include your order ID <strong style={{ color: "var(--amber)" }}>{selectedOrder.id}</strong> <CopyBtn value={selectedOrder.id} /> in the note.
                          </p>
                        </>
                      ) : (
                        <p style={{ fontSize: "13px", color: "var(--text-dim)" }}>Contact support for payment details.</p>
                      )}
                    </div>
                  );
                })()}
                {selectedOrder.shipping_address && (
                  <div style={{ background: "var(--surface2)", padding: 14, borderRadius: "var(--radius)", border: "1px solid var(--border)", marginBottom: 12 }}>
                    <p style={{ fontFamily: "var(--font-mono)", fontSize: "11px", color: "var(--text-muted)", marginBottom: 6, textTransform: "uppercase", letterSpacing: "0.05em" }}>Shipping Address</p>
                    <p style={{ fontSize: "14px", fontWeight: 600, marginBottom: 2 }}>{selectedOrder.shipping_address.name}</p>
                    <p style={{ fontSize: "13px", color: "var(--text-dim)", lineHeight: 1.5 }}>
                      {selectedOrder.shipping_address.street}{selectedOrder.shipping_address.street2 ? `, ${selectedOrder.shipping_address.street2}` : ""}<br />
                      {selectedOrder.shipping_address.city}, {selectedOrder.shipping_address.state} {selectedOrder.shipping_address.zip}
                    </p>
                  </div>
                )}
                {selectedOrder.payment_method === "card" && (
                  <div style={{ background: "var(--surface2)", padding: 14, borderRadius: "var(--radius)", border: "1px solid var(--border)", marginBottom: 12 }}>
                    <p style={{ fontFamily: "var(--font-mono)", fontSize: "11px", color: "var(--text-muted)", marginBottom: 6, textTransform: "uppercase", letterSpacing: "0.05em" }}>Billing Address</p>
                    {selectedOrder.billing_address ? (
                      <>
                        <p style={{ fontSize: "14px", fontWeight: 600, marginBottom: 2 }}>{selectedOrder.billing_address.name}</p>
                        <p style={{ fontSize: "13px", color: "var(--text-dim)", lineHeight: 1.5 }}>
                          {selectedOrder.billing_address.street}{selectedOrder.billing_address.street2 ? `, ${selectedOrder.billing_address.street2}` : ""}<br />
                          {selectedOrder.billing_address.city}, {selectedOrder.billing_address.state} {selectedOrder.billing_address.zip}
                        </p>
                      </>
                    ) : (
                      <p style={{ fontSize: "13px", color: "var(--text-dim)" }}>Same as shipping address</p>
                    )}
                  </div>
                )}
                {(selectedOrderLabels.length > 0 || selectedOrder.tracking) && (() => {
                  // Every live label on the order (original + reships). Falls back
                  // to the order's inline tracking if no label rows exist.
                  const labels = selectedOrderLabels.length > 0
                    ? selectedOrderLabels
                    : [{ id: "inline", tracking: selectedOrder.tracking, carrier: selectedOrder.carrier, kind: "original" }];
                  const trackingUrlFor = (l) => {
                    const c = (l.carrier || "usps").toUpperCase();
                    const urls = {
                      USPS: `https://tools.usps.com/go/TrackConfirmAction?tLabels=${l.tracking}`,
                      UPS: `https://www.ups.com/track?tracknum=${l.tracking}`,
                      FEDEX: `https://www.fedex.com/fedextrack/?trknbr=${l.tracking}`,
                    };
                    return { url: urls[c] || urls.USPS, name: { USPS: "USPS", UPS: "UPS", FEDEX: "FedEx" }[c] || c };
                  };
                  const kindLabel = { original: "", reship: " (RESHIP)", replacement: " (REPLACEMENT)", general: "" };
                  return (
                    <div style={{ background: "var(--surface2)", padding: 14, borderRadius: "var(--radius)", border: "1px solid var(--border)" }}>
                      {labels.map((l, li) => {
                        const t = trackingUrlFor(l);
                        return (
                          <div key={l.id || li} style={{ marginBottom: li < labels.length - 1 ? 14 : 0 }}>
                            <p style={{ fontFamily: "var(--font-mono)", fontSize: "11px", color: "var(--text-muted)", marginBottom: 4 }}>{t.name} TRACKING{kindLabel[l.kind] ?? ""}</p>
                            <div style={{ display: "flex", alignItems: "center", gap: 8, marginBottom: 6 }}>
                              <p style={{ fontFamily: "var(--font-mono)", fontSize: "13px", color: "var(--amber)" }}>{l.tracking}</p>
                              <CopyBtn value={l.tracking} />
                            </div>
                            <a href={t.url} target="_blank" rel="noopener noreferrer" style={{ color: "var(--amber)", fontFamily: "var(--font-mono)", fontSize: "12px", display: "inline-block" }}>Track on {t.name} →</a>
                          </div>
                        );
                      })}
                    </div>
                  );
                })()}
              </div>
            )}
          </Modal>

          {ordersLoading ? (
            <p style={{ fontFamily: "var(--font-mono)", fontSize: "12px", color: "var(--text-muted)", padding: "40px 0", textAlign: "center", letterSpacing: "0.1em" }}>LOADING ORDERS…</p>
          ) : orders.length === 0 ? (
            <div style={{ textAlign: "center", padding: "56px 0" }}>
              <p style={{ fontSize: "36px", marginBottom: 12 }}>📦</p>
              <h3 style={{ fontSize: "22px", marginBottom: 8 }}>No orders yet</h3>
              <p style={{ color: "var(--text-dim)", marginBottom: 24 }}>When you place an order, it'll show up here.</p>
              <Btn onClick={() => setView("shop")}>Start Shopping</Btn>
            </div>
          ) : (
            <div style={{ display: "flex", flexDirection: "column", gap: 10 }}>
              {orders.map(order => (
                <div key={order.id} onClick={() => setSelectedOrder(order)} style={{ background: "var(--surface)", border: "1px solid var(--border)", borderRadius: "var(--radius)", padding: "18px 22px", cursor: "pointer", transition: "border-color 0.15s", display: "flex", justifyContent: "space-between", alignItems: "center", flexWrap: "wrap", gap: 12 }}
                  onMouseEnter={e => e.currentTarget.style.borderColor = "var(--amber)"}
                  onMouseLeave={e => e.currentTarget.style.borderColor = "var(--border)"}>
                  <div>
                    <p style={{ fontFamily: "var(--font-mono)", fontSize: "14px", marginBottom: 4 }}>{order.id}</p>
                    <p style={{ color: "var(--text-dim)", fontSize: "13px" }}>{(order.order_items || []).map(i => i.name).join(", ")}</p>
                  </div>
                  <div style={{ display: "flex", gap: 14, alignItems: "center" }}>
                    <span style={{ fontFamily: "var(--font-mono)", fontSize: "12px", color: "var(--text-muted)" }}>{new Date(order.created_at).toLocaleDateString()}</span>
                    <Badge status={order.status} />
                    <span style={{ fontFamily: "var(--font-mono)", fontSize: "16px", color: "var(--amber)" }}>${Number(order.total).toFixed(2)}</span>
                    <span style={{ color: "var(--text-muted)", fontSize: "14px" }}>→</span>
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>
);

export default OrdersSection;
